import moment from 'moment'

export const randomInt = (max, min = 0) => Math.floor(Math.random() * (max - min)) + min
export const randomFloat = (max, min = 0) => (Math.random() * (max - min)) + min
export const randomItemInArray = array => array[randomInt(array.length)]
export const randomBoolean = () => Math.random() > 0.5
export const randomToken = (length = 36) => Math.random()
    .toString(length)
    .substr(2)

export const messageDate = (date, minutesToAdd) => (date ? moment(date) : moment()).add(minutesToAdd, 'minutes').format()
